import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Pagination = (props) => {
  const {
    itemCount,
    pageSize,
    currentPage,
    onPageChange,
    nextPage,
    previousPage,
    sliderSize = 8
  } = props;

  const pageCount = Math.ceil(itemCount / pageSize);
  if (itemCount === 0) return null;
  if (pageCount === 1) return null;
  const split = sliderSize / 2;
  const segment1 = sliderSize % 2 === 0 ? split : Math.floor(split);
  const segment2 = sliderSize % 2 === 0 ? split : Math.floor(split) + 1;

  //Pagination start & end
  const starting =
    currentPage + segment1 - 1 >= pageCount
      ? pageCount - sliderSize + 1
      : currentPage - segment1 > 1
      ? currentPage - segment1
      : 1;
  const ending =
    currentPage + segment2 - 1 >= pageCount
      ? pageCount + 1
      : currentPage + segment2 - 1 < sliderSize
      ? sliderSize + 1
      : currentPage + segment2;

  const pages = _.range(
    starting < 1 ? 1 : starting,
    ending > pageCount + 1 ? pageCount + 1 : ending
  );
  const previouspageClass = currentPage === 1 ? 'disabled' : '';
  const nextpageClass = currentPage === pageCount ? 'disabled' : '';
  const previousPageIcon = (
    <li
      className={`page-item ${previouspageClass}`}
      onClick={() => previousPage(currentPage, previouspageClass)}
    >
      <span className='page-link'>&laquo;</span>
    </li>
  );
  const nextPageIcon = (
    <li
      className={`page-item ${nextpageClass}`}
      onClick={() => nextPage(currentPage, nextpageClass)}
    >
      <span className='page-link'>&raquo;</span>
    </li>
  );
  const FirstPage = (
    <li
      className={`page-item ${previouspageClass}`}
      onClick={() => onPageChange(1)}
    >
      <span className='page-link'>First</span>
    </li>
  );
  const LastPage = (
    <li
      className={`page-item ${nextpageClass}`}
      onClick={() => onPageChange(pageCount)}
    >
      <span className='page-link'>Last</span>
    </li>
  );
  return (
    <nav aria-label='...'>
      <ul className='pagination pagination-sm justify-content-end'>
        {previousPageIcon}
        {pageCount >= sliderSize && FirstPage}
        {pages.map((p) => (
          <li
            className={p === currentPage ? 'page-item active' : 'page-item'}
            style={{ cursor: 'pointer' }}
            key={p}
            onClick={() => onPageChange(p)}
            aria-current='page'
          >
            <span className='page-link'>{p}</span>
          </li>
        ))}
        {pageCount >= sliderSize && LastPage}
        {nextPageIcon}
      </ul>
    </nav>
  );
};

Pagination.propTypes = {
  itemCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

export default Pagination;
